"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.quoteSortList = exports.EmptyExchangeSymbolDataItem = exports.EmptyExchangeSymbolData = exports.VIRTUAL_CURRENCY = void 0;
const trade_utils_lib_1 = require("trade_utils_lib");
const SymbolMap_1 = require("./SymbolMap");
/**虚拟币的名字 */
exports.VIRTUAL_CURRENCY = "VUJZYX";
exports.EmptyExchangeSymbolData = {
    allSymbols: [],
    spotSymbolData: {
        symbolType: trade_utils_lib_1.ExchangeSymbolType.spot,
        symbols: [],
        map: new SymbolMap_1.SymbolMap(),
        quotes: [],
    },
    futurePSymbolData: {
        symbolType: trade_utils_lib_1.ExchangeSymbolType.future_perpetual,
        symbols: [],
        map: new SymbolMap_1.SymbolMap(),
        quotes: [],
    },
    symbolMap: new SymbolMap_1.SymbolMap(),
};
exports.EmptyExchangeSymbolDataItem = {
    symbolType: trade_utils_lib_1.ExchangeSymbolType.unknown,
    symbols: [],
    map: new SymbolMap_1.SymbolMap(),
    quotes: [],
};
exports.quoteSortList = ["BTC", "ETH", "USDT"];
